import React, { useEffect, useState } from 'react'

import { message, Select, Spin } from 'antd'
import { FaSearch } from 'react-icons/fa'
import { TbMessageQuestion } from 'react-icons/tb'

import '../../playbooks/styles.scss'
import CustomTable from '../../../../assets/component/table'
import { useDispatch, useSelector } from 'react-redux'
import ManageFilters from '../../../../assets/component/manage-filters'
import { playbookNameDropdown, playbookNameDropdownReset } from '../../../../store/slices/manage-playbook/playbookNameDropdown'
import { viewPlaybookAction, viewPlaybookReset } from '../../../../store/slices/manage-playbook/playbook'
import { TextConcat } from '../../../../helpers/text-concat'


const CustomPlaybookMain = ({ setQuestionInput, setPresetQuestion, isModalContent, handleShowPromptsModal, setPlaybookId, playbookId, promptEvaluationFlag, promptType, setSelectedQuestion, chunkEvaluation, setSliderValue, handleShowEditModal }) => {
    const [search, setSearch] = useState("")
    const [selectedPlaybook, setSelectedPlaybook] = useState(null)
    const [promptTableData, setPromptTableData] = useState([])
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [showFilters, setShowFilters] = useState(true)
    const [tableStats, setTableStats] = useState({ totalPages: '', totalRecords: '' })

    const dispatch = useDispatch()
    const { data: playbookNameData, isLoading: playbookDropdownLoading } = useSelector((state) => state?.playbookNameDropdown)
    const { data: playbookData, isLoading: playbookLoading } = useSelector((state) => state?.viewPlaybook)

    const promptTableHeaderData = [
        {
            title: "DP Codes",
            dataIndex: "dpCode",
            key: "dpCode",
            width: 150,
            render: (text) => (<TextConcat text={text} maxLength={100} />),
            sorter: (a, b) => a.dpCode?.localeCompare(b.dpCode),
        },
        {
            title: "Criteria",
            dataIndex: "criteria",
            key: "criteria",
            width: 150,
            render: (text) => (<TextConcat text={text} maxLength={100} />),
            sorter: (a, b) => a.criteria?.localeCompare(b.criteria),
        },
        {
            title: "Inclusion",
            dataIndex: "inclusion",
            key: "inclusion",
            width: 150,
            render: (text) => (<TextConcat text={text} maxLength={100} />),
            sorter: (a, b) => a.inclusion?.localeCompare(b.inclusion),
        },
        {
            title: "Exclusion",
            dataIndex: "exclusion",
            key: "exclusion",
            width: 150,
            render: (text) => (<TextConcat text={text} maxLength={100} />),
            sorter: (a, b) => a.exclusion?.localeCompare(b.exclusion),
        },
        {
            title: "Important Note",
            dataIndex: "importantNote",
            key: "importantNote",
            width: 150,
            render: (text) => (<TextConcat text={text} maxLength={100} />),
            sorter: (a, b) => a.importantNote?.localeCompare(b.importantNote),
        },
        {
            title: "Search Query",
            dataIndex: "searchQuery",
            key: "searchQuery",
            width: 150,
            render: (text) => (<TextConcat text={text} maxLength={100} />),
            sorter: (a, b) => a.searchQuery?.localeCompare(b.searchQuery),
        },
        {
            title: "Final Unit",
            dataIndex: "finalUnits",
            key: "finalUnit",
            width: 150,
            render: (text) => (<TextConcat text={text} maxLength={100} />),
            sorter: (a, b) => a.finalUnits?.localeCompare(b.finalUnits),
        },
        {
            title: "Data Type",
            dataIndex: "dataType",
            key: "dataType",
            width: 150,
            render: (text) => (<TextConcat text={text} maxLength={100} />),
            sorter: (a, b) => a.dataType?.localeCompare(b.dataType),
        },
        {
            title: "",
            dataIndex: "actions",
            key: "actions",
            width: 150,
        },
    ];

    const resetFilters = async () => {
        setSearch('')
        setSelectedPlaybook(null)
        setPlaybookId(null)
        setPage(1)
        setLimit(limit)
        dispatch(viewPlaybookReset())
        setPromptTableData({ dataSource: [], columns: promptTableHeaderData })
    }

    const handleChangePlaybook = (value, option) => {
        setSelectedPlaybook(value)
        setPlaybookId(value)
        setSelectedQuestion((prev) => ({
            ...prev,
            selectedRow: {
                playbookName: option?.label, playbookId: value
            }
        }))
    }

    const handleSearch = (e) => {
        setSearch(e.target.value)
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            searchBasedFilter()
        }
    }


    const handleRowSelection = ({ selectedRow }) => {
        if (selectedRow?.question) {
            setPresetQuestion(selectedRow?.presetQuestion)
            setQuestionInput(selectedRow?.question)

            if (handleShowPromptsModal) {
                handleShowPromptsModal()
            }
        }
        else if (promptEvaluationFlag) {
            let formattedText = `Criteria:\n${selectedRow?.criteria
                .replace(/\r\n/g, '\n')}`;

            if (selectedRow?.inclusion || selectedRow?.exclusion || selectedRow?.note) {
                if (selectedRow?.inclusion) {
                    formattedText += `\nInclude:\n${selectedRow.inclusion
                        .replace(/\r\n/g, '\n')}`;
                }
                if (selectedRow?.exclusion) {
                    formattedText += `\nExclude:\n${selectedRow.exclusion
                        .replace(/\r\n/g, '\n')}`;
                }
                if (selectedRow?.importantNote) {
                    formattedText += `\n${selectedRow.importantNote
                        .replace(/\r\n/g, '\n')}`;
                }
            }
            setQuestionInput(formattedText)
            setSelectedQuestion((prev) => ({
                ...prev,
                selectedRow: {
                    ...prev.selectedRow,
                    ...selectedRow
                }
            }))
            if (handleShowPromptsModal) {
                handleShowPromptsModal()
            }
        } else if (chunkEvaluation) {
            if (!selectedRow?.searchQuery || selectedRow?.searchQuery?.length === 0) {
                message.error("The Search Query Cannot be empty. Please provide search query by clicking Edit Question to proceed!");
                setQuestionInput("")
                if (handleShowPromptsModal) {
                    handleShowPromptsModal()
                }
                setSelectedQuestion((prev) => ({
                    ...prev,
                    selectedRow: {
                        ...prev.selectedRow,
                        ...selectedRow,
                        searchQuery: "",
                        fts: "",
                        vts: ""
                    }
                }));
                setSliderValue({
                    vectorWeight: "0.8",
                    keywordWeight: "0.2"
                })
                return
            }
            // setEditModal(false);
            setQuestionInput(selectedRow?.searchQuery)
            setSelectedQuestion((prev) => ({
                ...prev,
                selectedRow: {
                    ...prev.selectedRow,
                    ...selectedRow
                }
            }))
            setSliderValue({
                vectorWeight: selectedRow?.vts,
                keywordWeight: selectedRow?.fts
            })
            if (handleShowPromptsModal) {
                handleShowPromptsModal()
            }
        }
    }

    const searchBasedFilter = () => {
        const searchTerm = search?.trim()?.toLowerCase();

        const filteredData = playbookData?.responseData?.questionData?.filter(({ dpCode }) => {
            const dpCodeText = dpCode?.toLowerCase() || '';
            return dpCodeText.includes(searchTerm);
        });

        const formattedData = filteredData?.map(row => formatTableRow({ rowDetails: row }));

        setPromptTableData({
            dataSource: formattedData,
            columns: promptTableHeaderData,
        });
    };

    const formatTableRow = ({ rowDetails }) => {
        const ActionItems = () => {
            return (
                <div className="action-buttons-container">
                    <div className="action-button regenerate-question" onClick={() => handleRowSelection({ selectedRow: rowDetails })}>
                        Ask <TbMessageQuestion className="icon" />
                    </div>
                </div>
            )
        }

        return {
            ...rowDetails,
            actions: <ActionItems />,
        }
    }

    const handleShowFiltersSection = () => {
        setShowFilters(!showFilters)
    }

    const handleResize = () => {
        if (window.innerWidth > 1024) {
            setShowFilters(true)
        }
    }

    useEffect(() => {
        handleResize()
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize) //Clean up
        }
    }, [])

    useEffect(() => {
        if (playbookId) {
            const promptPayload = {
                playbookId: playbookId,
            }
            dispatch(viewPlaybookAction(promptPayload))
        }
    }, [playbookId])

    useEffect(() => {
        const sourceData = playbookData?.responseData?.questionData;
        const structuredData = sourceData?.map(row => formatTableRow({ rowDetails: row }));
        const columnsHeaderData = promptTableHeaderData
        setPromptTableData({ dataSource: structuredData, columns: columnsHeaderData })
        setSelectedPlaybook(playbookData?.responseData?.playbookName)
    }, [playbookData?.responseData])

    useEffect(() => {
        setTableStats({
            totalPages: playbookData?.responseData?.totalPages,
            totalRecords: playbookData?.responseData?.totalRecords,
        })
    }, [playbookData])

    useEffect(() => {
        dispatch(viewPlaybookReset())
        if ((promptEvaluationFlag || chunkEvaluation) && !playbookNameData?.filterData) {
            const payload = {
                isDropDownValues: true,
            }
            dispatch(playbookNameDropdownReset())
            dispatch(playbookNameDropdown(payload))
        }
    }, [playbookNameData])

    return (
        <>
            <div className={`promt-main-container ${isModalContent ? 'prompt-main-modal' : 'prompt-main-full-screen'}`}>
                <div className="prompt-filters-section-wrapper">
                    {showFilters && (
                        <div className="prompt-filters-section">
                            {isModalContent && (
                                <div className="input-wrapper">
                                    <Select
                                        showSearch
                                        className="prompt-select"
                                        popupClassName="prompt-react-select"
                                        options={playbookNameData?.filterData || []}
                                        onChange={(value, option) => handleChangePlaybook(value, option)}
                                        value={selectedPlaybook}
                                        placeholder="Select Playbook"
                                        maxLength={2}
                                        filterOption={(input, option) => option?.label?.toLowerCase()?.includes(input?.toLowerCase())}
                                        notFoundContent={playbookDropdownLoading ? <div className="dropdown-loading"><Spin size="small" /></div> : "No Data"}
                                    />
                                </div>
                            )}
                            <div className="search-wrapper">
                                <input type="text" className="search-input" placeholder="Search DP Code" value={search} onChange={(e) => handleSearch(e)} onKeyDown={(e) => handleKeyPress(e)} />
                                <FaSearch className={`search-icon ${search ? 'active-icon' : ''}`} onClick={searchBasedFilter} />
                            </div>
                            <div className="prompt-filter-buttons">
                                <div className="filter-button apply-button" onClick={searchBasedFilter}>
                                    Apply
                                </div>
                                <div className="filter-button reset-button" onClick={() => resetFilters()}>
                                    Reset
                                </div>
                            </div>
                        </div>
                    )}
                    <ManageFilters showFilters={showFilters} handleShowFiltersSection={handleShowFiltersSection} />
                </div>
                <div className="prompt-main-body">
                    <CustomTable isLoading={playbookLoading} limit={limit} setLimit={setLimit} page={page} setPage={setPage} totalRows={tableStats?.totalRecords} tableData={promptTableData} />
                </div>
            </div>
        </>
    )
}

export default CustomPlaybookMain
